import { convertStringsToDates } from 'design-system-web';
import { ExternalPayerType as gqlPayerType } from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';
import { ChargeQueryString } from './useGetChargeTableFilters';

export function buildChargeFilters(filterParams: ChargeQueryString) {
  const payers = [];

  if (filterParams?.payer) {
    const prefix = filterParams.payer[0];
    const id = filterParams.payer.slice(2);

    payers.push({
      type:
        prefix === 'c'
          ? gqlPayerType.ExternalPayerTypeActivateCompany
          : gqlPayerType.ExternalPayerTypeActivateUser,
      ids: [convertToUUID(id)],
    });
  }

  const statuses = filterParams?.status
    ? filterParams.status.split(',').filter(Boolean)
    : [];

  const dateRange = filterParams?.createdAt
    ? convertStringsToDates(filterParams.createdAt)
    : undefined;

  if (!payers.length && !statuses.length && !dateRange) {
    return undefined;
  }

  return {
    ...(statuses.length ? { statuses } : {}),
    ...(dateRange
      ? {
          createdDateRange: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
          },
        }
      : {}),
    ...(payers.length ? { payers } : {}),
  };
}
